import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../config";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "border-b border-navy-900/10 bg-white/90 shadow-[0_1px_28px_rgba(10,30,66,0.07)] backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <a
          href="#home"
          data-testid="header-logo-link"
          aria-label="EXIMNEX Technologies — Home"
          className="flex items-center gap-3"
        >
          <img src="/logo-mark.webp" alt="EXIMNEX Technologies logo" className="h-11 w-11" />
          <span className="leading-none">
            <span className="block text-lg font-bold tracking-[0.06em] text-navy-900">
              EXIMNEX
            </span>
            <span className="mt-1 block text-[9px] font-semibold uppercase tracking-[0.42em] text-royal">
              Technologies
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-10 md:flex" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`desktop-nav-${l.id}`}
              className="text-[12.5px] font-semibold uppercase tracking-[0.16em] text-navy-900/60 transition-colors duration-300 hover:text-royal"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="inline-flex h-11 w-11 items-center justify-center rounded-full text-navy-900 transition-colors hover:bg-navy-900/5 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-navy-900/10 bg-white/95 backdrop-blur-md md:hidden">
          <nav className="flex flex-col px-6 py-4" aria-label="Mobile">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={`mobile-nav-${l.id}`}
                onClick={() => setOpen(false)}
                className="border-b border-navy-900/5 py-4 text-sm font-semibold uppercase tracking-[0.14em] text-navy-900/75 last:border-0 transition-colors hover:text-royal"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
